<div class="settings-subtab-bar">
    <div class="container-fluid settings-tabs d-flex align-items-center">
        <div class="settings-subtabs d-flex align-items-center gap-4">
            <div class="settings-subtab-item" [class.active]="activeMasterTab === 'employees'"
                [routerLink]="['/home/users']" (click)="activeMasterTab = 'employees'">
                Employees
            </div>
            <div class="settings-subtab-item" [class.active]="activeMasterTab === 'roles'"
                [routerLink]="['/home/roles']" (click)="activeMasterTab = 'roles'">
                Roles
            </div>
            <div class="settings-subtab-item" [class.active]="activeMasterTab === 'departments'"
                [routerLink]="['/home/department']" (click)="activeMasterTab = 'departments'">
                Departments
            </div>
             <div *ngIf="isCaratredSupervisor" class="settings-subtab-item" [class.active]="activeMasterTab === 'company'"
                [routerLink]="['/home/company']" (click)="activeMasterTab = 'company'">
                Company
            </div>
             <div *ngIf="isCaratredSupervisor" class="settings-subtab-item" [class.active]="activeMasterTab === 'modules'"
                [routerLink]="['/home/modules']" (click)="activeMasterTab = 'modules'">
                Modules
            </div>
        </div>
    </div>
</div>
